import { AppSettings } from '../AppSettings';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class SignupService {
  constructor(private http: Http) { }

  register(username: string, password: string, name: string) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post(AppSettings.SERVICE_ENDPOINT + '/api/register', JSON.stringify({ username: username, password: password, name: name }), {
      headers: headers
    }).map((response: Response) => {
      // signup successful if there's a jwt token in the response
      let user = response.json();
      if (user && user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //        localStorage.setItem('currentUser', JSON.stringify(user));
      }
    });
  }


}


// WEBPACK FOOTER //
// ./src/app/signup/signup.service.ts